import React from "react";
import { Pagination as MuiPagination, PaginationItem } from "@mui/material";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (_, value) => {
    onPageChange(value);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        variant="outlined"
        shape="rounded"
        renderItem={(item) => (
          <PaginationItem
            {...item}
            style={{
              fontWeight: item.selected ? "bold" : "normal",
              color: item.selected ? "#1976d2" : "inherit",
            }}
          />
        )}
      />
    </div>
  );
};

export default Pagination;
